import React from "react";
import { Tag, Space, Typography, Tooltip, Dropdown, Button } from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

export const getSupplierColumns = ({
  onView,
  onEdit,
  onDeactivate,
  onActivate,
}) => [
    {
      title: "Supplier Name",
      dataIndex: "supplierName",
      key: "supplierName",
      sorter: (a, b) => String(a?.supplierName ?? "").localeCompare(String(b?.supplierName ?? "")),
      render: (text, record) => (
        <Space direction="vertical" size={2}>
          <Text
            strong
            style={{ cursor: "pointer", color: "#294DD8" }}
            onClick={() => onView?.(record.supplierId, record.status)}
          >
            {text || "-"}
          </Text>
        </Space>
      ),
    },
    {
      title: "Contact Person",
      dataIndex: "pocName",
      key: "pocName",
      sorter: (a, b) => String(a?.pocName ?? "").localeCompare(String(b?.pocName ?? "")),
      render: (text, record) => (
        <Space direction="vertical" size={2}>
          <Text>{text || "-"}</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {record.pocMobile || "-"}
          </Text>
        </Space>
      ),
    },
    {
      title: "Email",
      dataIndex: "pocEmail",
      key: "pocEmail",
      render: (email) => <Text>{email || "-"}</Text>,
    },
    // {
    //   title: "Bank Details",
    //   key: "bankDetails",
    //   render: (_, record) => {
    //     if (!record.accNum && !record.ifsc) return <Text type="secondary">-</Text>;
    //     const maskedAcc = record.accNum
    //       ? `•••• ${String(record.accNum).slice(-4)}`
    //       : "";
    //     return (
    //       <Space direction="vertical" size={2}>
    //         <Text strong>
    //           {record.bankName || "Bank"} {maskedAcc}
    //         </Text>
    //         <Space size={4}>
    //           <Text type="secondary" style={{ fontSize: 12 }}>
    //             IFSC: {record.ifsc || "-"}
    //           </Text>
    //           {record.isBankVerified ? (
    //             <Tag
    //               color="success"
    //               style={{ fontSize: 10, lineHeight: "16px", padding: "0 4px" }}
    //             >
    //               Verified
    //             </Tag>
    //           ) : (
    //             <Tag
    //               color="default"
    //               style={{ fontSize: 10, lineHeight: "16px", padding: "0 4px" }}
    //             >
    //               Unverified
    //             </Tag>
    //           )}
    //         </Space>
    //       </Space>
    //     );
    //   },
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => String(a?.status ?? "").localeCompare(String(b?.status ?? "")),
      render: (status) => {
        if (status === "ACTIVE") {
          return <Tag color="success">Active</Tag>;
        }
        if (status === "INACTIVE") {
          return <Tag color="error">Inactive</Tag>;
        }
        return <Tag color="warning">{status || "Pending"}</Tag>;
      },
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      render: (text, record) => {
        const val = text || record?.remarks || record?.reason;
        return val ? (
          <Tooltip title={val}>
            <Text type="secondary" ellipsis style={{ maxWidth: 160, display: "block" }}>
              {val}
            </Text>
          </Tooltip>
        ) : (
          <Text type="secondary">-</Text>
        );
      },
    },
    {
      title: "Onboarded Date",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => {
        const timeA = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
        const timeB = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
        return (Number.isFinite(timeA) ? timeA : 0) - (Number.isFinite(timeB) ? timeB : 0);
      },
      render: (date) => (date ? dayjs(date).format("DD/MM/YYYY") : "-"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const menuItems = [
          {
            key: "view",
            label: "View",
            onClick: () => onView?.(record.supplierId, record.status),
          },

          // Show Edit only when supplier is ACTIVE
          ...(record.status === "ACTIVE"
            ? [
              {
                key: "edit",
                label: "Edit",
                onClick: () => onEdit?.(record),
              },
            ]
            : []),

          // Activate / Deactivate
          record.status === "ACTIVE"
            ? {
              key: "deactivate",
              label: "Deactivate",
              danger: true,
              onClick: () => onDeactivate?.(record),
            }
            : {
              key: "activate",
              label: "Activate",
              onClick: () => onActivate?.(record),
            },
        ];

        return (
          <Dropdown
            menu={{ items: menuItems }}
            trigger={["click"]}
          >
            <Button type="text">⋮</Button>
          </Dropdown>
        );
      },
    },
  ];
